import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import ReadingFlagIcon from 'components/ReadingFlagIcon';
import Account from 'modules/Account';
import MetricConversions from 'libs/MetricConversions';
import Droplet from 'svg/average-blood.svg';
import styles from './Measurement.pcss';
const Measurement = ({ element })=>{
    useStyles(styles);
    const metricsUnits = useSelector(Account.selectors.metricsUnits);
    const metricConversions = new MetricConversions(metricsUnits);
    const conversion = metricConversions.bloodGlucoseConcentration;
    const { displayValue, timestamp, flag, type } = element;
    const measurementTypeClass = styles[`measurement__resultIcon--${type}`];
    const formattedDate = moment.unix(timestamp).utc().format('L');
    const formattedTime = moment.unix(timestamp).utc().format('LT');
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.measurement__result,
        children: [
            /*#__PURE__*/ _jsx(Droplet, {
                className: styles.measurement__droplet
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.measurement__datetime,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: formattedDate
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: formattedTime
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.measurement__value,
                children: [
                    /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                        className: `${styles.measurement__resultIcon} ${measurementTypeClass}`,
                        flag: flag
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.measurement__resultText,
                        children: `${displayValue} ${conversion.unitSymbol}`
                    })
                ]
            })
        ]
    }, `${timestamp}-${flag}-${type}-${displayValue}`);
};
export default /*#__PURE__*/ memo(Measurement);
